import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import React from "react";

import { SDUISectionInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { FilterablePaginatedSectionComponentsColumnRenderer } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Components/FilterablePaginatedSectionComponentsColumnRenderer";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";

export const SDUIFilterablePaginatedSectionComponentsColumnNonRSC: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filterablePaginatedSection: IFilterablePaginatedSection;
  }
> = ({
  filterablePaginatedSection,
  componentRenderers,
  sectionLoggingData,
}) => {
  const {
    isFilterLoading,
    isFilteredComponentsFetching,
    filteredComponentsData,
  } = useFilterablePaginatedSectionQuery(filterablePaginatedSection);

  return (
    <FilterablePaginatedSectionComponentsColumnRenderer
      filteredComponentsData={filteredComponentsData}
      isFilterLoading={isFilterLoading}
      isFilteredComponentsFetching={isFilteredComponentsFetching}
      componentRenderers={componentRenderers}
      sectionLoggingData={sectionLoggingData}
    />
  );
};
